import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Pagination = ({ currentPage, totalPages, totalItems, pageSize, onPageChange }) => {
    if (totalPages <= 1) return null;
    const startItem = (currentPage - 1) * pageSize + 1;
    const endItem = Math.min(currentPage * pageSize, totalItems);

    return (
        <div className="pagination-bar">
            <span>Showing {startItem}-{endItem} of {totalItems}</span>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button
                    className="btn btn-sm"
                    style={{ background: '#6c757d', color: 'white' }}
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    <FaChevronLeft /> Prev
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button
                    className="btn btn-sm"
                    style={{ background: '#6c757d', color: 'white' }}
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    Next <FaChevronRight />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
